import React, { useCallback } from "react";
import { useDebounceCallback } from "@/hooks/util/useDebounceCallback";
import { type NumberFormatValues, NumericFormat } from "react-number-format";

type InputFieldType = "from" | "to";
export type InputFieldFormat = "dollar" | "percent" | "decimal";

interface GridBarFiltersAtomInputRangeProps {
  onChange?: (from: number, to: number) => void;
  from: number;
  to: number;
  min: number;
  max: number;
  type: InputFieldFormat;
}

export default function GridBarFiltersAtomInputRange({ to, from, max, min, onChange, type }: GridBarFiltersAtomInputRangeProps) {
  const handleInputAmountChange = useCallback(
    (values: NumberFormatValues, type: InputFieldType) => {
      if (values.floatValue !== undefined) {
        onChange?.(type === "from" ? values.floatValue : from, type === "to" ? values.floatValue : to);
      }
    },
    [from, onChange, to]
  );

  const handleInputChangeDebounced = useDebounceCallback(handleInputAmountChange, 500);

  const validateInput = useCallback((value: NumberFormatValues) => (value.floatValue !== undefined ? value.floatValue >= min && value.floatValue <= max : true), [max, min]);

  return (
    <div className="mb-2 flex h-12 w-full justify-stretch space-x-2">
      <NumericFormat
        value={from.toString()}
        className="h-full w-1/2 flex-1 border-0.5 border-neutral-300 bg-neutral-50 px-3 font-mono antialiased outline-0 transition-colors duration-200 focus:border-neutral-500"
        onValueChange={values => handleInputChangeDebounced(values, "from")}
        decimalSeparator={"."}
        isAllowed={validateInput}
        thousandSeparator=","
        allowNegative={min < 0}
        prefix={type === "dollar" ? "$" : undefined}
        suffix={type === "percent" ? "%" : undefined}
      />
      <NumericFormat
        value={to.toString()}
        thousandSeparator=","
        className="h-full w-1/2 flex-1 border-0.5 border-neutral-300 bg-neutral-50 px-3 font-mono antialiased outline-0 transition-colors duration-200 focus:border-neutral-500"
        onValueChange={values => handleInputChangeDebounced(values, "to")}
        decimalSeparator={"."}
        allowNegative={min < 0}
        prefix={type === "dollar" ? "$" : undefined}
        suffix={type === "percent" ? "%" : undefined}
      />
    </div>
  );
}
